// store/use-dialog-store.ts
import { create } from "zustand";

interface DialogConfig {
  title: string;
  description: string;
  cancelText?: string;
  confirmText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

interface DialogStore {
  isOpen: boolean;
  config: DialogConfig | null;
  openDialog: (config: DialogConfig) => void;
  closeDialog: () => void;
}

export const useDialogStore = create<DialogStore>((set) => ({
  isOpen: false,
  config: null,
  openDialog: (config) => set({ isOpen: true, config }),
  closeDialog: () => set({ isOpen: false, config: null }),
}));
